<template>
  <div class="new-secondary-user">
    <div class="columns is-multiline">
      <div class="column is-12 is-12-mobile is-6">
        <BField
          label="Nombre"
          label-for="privateName"
        >
          <BInput
            id="privateName"
            v-model="privateName"
            placeholder="Rafaeli Camposorio Ruízo"
            icon="account"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('name', $event)"
          />
        </BField>
      </div>
      <div class="column is-12 is-12-mobile is-6">
        <BField
          label="Email"
          label-for="privateEmail"
        >
          <BInput
            id="privateEmail"
            v-model="privateEmail"
            placeholder="correo@mail.com"
            icon="email"
            type="email"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('email', $event)"
          />
        </BField>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewSecondaryUser',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      privateName: this.$store.state.users.name,
      privateEmail: this.$store.state.users.email,
    };
  },
  beforeDestroy() {
    this.$store.commit('users/setValues', {
      name: '',
      email: '',
    });
  },
  methods: {
    onInput(name, event) {
      this.$store.commit('users/setValue', { accessor: name, value: event });
    },
  },
};
</script>

<style scoped>
.field.has-addons.unionized .control {
  width: 50%;
}
</style>

<style>
.unionized-radiobutton .b-radio {
  width: 100%;
}
</style>
